"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const InputIcon = _ref => {
  let {
    materialIconName
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("span", {
    className: "icon is-small is-left"
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: "material-icons"
  }, materialIconName));
};
InputIcon.propTypes = {
  materialIconName: _propTypes.default.string.isRequired
};
var _default = exports.default = InputIcon;
//# sourceMappingURL=InputIcon.js.map